import React from 'react';
import { CLASSES } from '../constants/landUseConfig';

interface Props {
  showChangedLegend: boolean;
}

export const LegendBar: React.FC<Props> = ({ showChangedLegend }) => {
  return (
    <>
      <div className="flex flex-wrap gap-6 mt-4 text-sm">
        {CLASSES.map((c) => (
          <div key={c.id} className="flex items-center gap-2">
            <div
              className="w-4 h-4 border border-gray-900"
              style={{ backgroundColor: c.fill }}
            />
            <span>{c.label}</span>
          </div>
        ))}
        <div className="flex items-center gap-2 text-gray-600">
          <div className="w-4 h-4 border border-dashed border-gray-900" />
          <span>soil texture overlay (organic ↔ mineral)</span>
        </div>
      </div>

      {showChangedLegend && (
        <div className="flex items-center gap-2 mt-2 text-sm">
          <div className="w-4 h-4 border-[3px] border-dashed border-gray-900 bg-white" />
          <span>parcel reassigned by the optimizer (★ marker = new class)</span>
        </div>
      )}
    </>
  );
};